<template>
  <div class="page-theme-selector">
    <Alert v-if="isCustomTheme" class="page-mutate-theme__custom" data-field="themes">{{
      $t('customThemeActiveMessage')
    }}</Alert>

    <div v-else class="page-mutate-theme__items">
      <ThemeCard
        v-for="theme in themes"
        :key="'theme_' + theme.value"
        :value="theme"
        :active="theme.value === value"
        @select="$emit('input', theme.value)"
        :disabled="disabled"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ThemeCard from '@/components/Project/ThemeCard.vue'
import { AlertComponent as Alert } from 'vue-elder-alert'

export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    value: String,
    isSlot: Boolean,
    disabled: Boolean,
  },
  computed: {
    ...mapState({
      themes(state) {
        return (state.enums.Themes || []).filter(({ type }) => type === 'page')
      },
    }),
    isCustomTheme() {
      if (!this.value) return false
      if (!this.themes.length) return false
      return !this.currentTheme
    },
    currentTheme() {
      return this.themes.find(t => t.value === this.value)
    },
  },
  components: {
    ThemeCard,
    Alert,
  },
}
</script>
